import { render } from "./PropertyFolderEditor.vue?vue&type=template&id=5488c9cb&scoped=true&ts=true"
import script from "./PropertyFolderEditor.vue?vue&type=script&lang=ts"
export * from "./PropertyFolderEditor.vue?vue&type=script&lang=ts"

import "./PropertyFolderEditor.vue?vue&type=style&index=0&id=5488c9cb&scoped=true&lang=css"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5488c9cb"]])

export default __exports__